
// M030 contact list
function updateContactList() {

    if ($(".contactListElement").length > 0) {
        var hh = 0;

        $(".contactListElement").css("height", "auto");
        $(".contactListElement").each(function () {
            if ($(this).height() > hh) {
                hh = Math.ceil($(this).outerHeight());
            }
        });
        if (hh > 0) {
            $(".contactListElement").css("height", hh + "px");
        }
    }
}